import React from 'react';
import { Helmet } from 'react-helmet-async';

/** Keeps the logo favicon on every route, including post-auth pages. */
export const DocumentHead = () => (
  <Helmet>
    <link rel="icon" type="image/x-icon" href="/favicon.ico" sizes="any" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <link rel="apple-touch-icon" sizes="180x180" href="/favicon.svg" />
  </Helmet>
);
